define('models/modals/goods-card/index',['require','lib/utils','config/application','models/base/model','models/base/modal'],function(require) {
    'use strict';

    var utils = require('lib/utils'),
        appCfg= require('config/application'),
        Model = require('models/base/model'),
        ModalModel = require('models/base/modal');

    var GoodsCardModalContent = Model.extend({
        timerEnabled: true,
        timerInterval: 60000,
        urlPath: function() {
            return '/api/goods-info';
        },
        defaults: {
            goodsId: null,
            photoExists: false,
            idTradeGoods: null,
            sellerName: '',
            goodsCountryName: '',
            vendor: '',
            freshness: null,
            quality: null,
            rateExp: null,
            amount: 0,
            traderViewPrice: 0,
            canBuy: false,
            minLot: 0,
            basketAmount: 0,
            unit: '',
            viewCurrency: '',
            basketComment: '',
            tradeAccessInstantOrder: 0,
            favoriteId: null
        },
        initialize: function() {
            Model.prototype.initialize.apply(this, arguments);
        },
        parse: function(data){
            data.basketAmount = data.basketAmount === null ? 0 : data.basketAmount;

            data.fullName = data.goodsTypeName + ' ' + data.goodsName + ' ' + data.Length;
            if (data.vendor !== data.sellerName) {
                data.fullName = data.fullName + ' (' + data.vendor + ')';
            }

            this.canBuy(data);
            this.timerStart();
            return data;
        },
        canBuy: function(data) {
            var et, ct, canBuy,
            startTime = data ? data.tradeStartTime : this.get('tradeStartTime'),
            endTime  = data ? data.tradeEndTime : this.get('tradeEndTime'),
            startTimeOnline = data ? data.startTimeOnline : this.get('startTimeOnline'),
            endTimeOnline = data ? data.endTimeOnline : this.get('endTimeOnline');

            ct = (new Date()).getTime();
            canBuy = false;

            if (startTime) {
                et = (new Date(endTime)).getTime();
                canBuy = (ct <= et);
            }

            if (startTimeOnline) {
                et = (new Date(endTimeOnline)).getTime();
                canBuy = canBuy || (ct <= et);
            }

            canBuy = canBuy || (appCfg.environment === 'development');

            this.set('canBuy', canBuy);

            return canBuy;
        },
        timerStart: function() {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            if (!this.timerEnabled) { return; }

            var _this = this;

            this.timeout = setTimeout(function() {
                _this.timeout = null;

                if (!_this.timerEnabled) { return; }

                _this.canBuy();
                _this.timerStart();

            }, this.timerInterval);
        },
        urlParams: function() {
            var params = Model.prototype.urlParams.apply(this, arguments);
            params.tradeId = this.get('tradeId');
            params.organizationOfferId = this.get('organizationOfferId');
            params.tradeGoodsId = this.get('tradeGoodsId');
            return params;
        },
        dispose: function(){
            if (this.disposed) { return; }

            if (this.timeout) { clearTimeout(this.timeout); }

            Model.prototype.dispose.apply(this, arguments);

        }
    });

    var GoodsCardModalModel = ModalModel.extend({
        defaults: {
            'title': '',
            'buttons': [],
            body: '',
            showFooter: false
        },
        constructor: function() {
            ModalModel.apply(this, arguments);

            var self = this;
            this.content = new GoodsCardModalContent({
                tradeId: this.get('tradeId'),
                organizationOfferId: this.get('organizationOfferId'),
                tradeGoodsId: this.get('tradeGoodsId')
            });
            this.content.on('afterLoad', function() {
                self.trigger('afterLoad');
            });
        },
        dispose: function() {
            if (this.disposed) { return; }
            this.content.dispose();
            ModalModel.prototype.dispose.apply(this, arguments);
        }
    });

    return GoodsCardModalModel;
});

